export default __webpack_public_path__ + "static/pphh-logo-8decf5662f9d60b5fcd18fd184662e33.svg";